import { RootState } from './store'

export const getAlertsState = (state: RootState) => state?.alerts
